import CmsComponentButton from "@/helpers/editor/components/CmsComponentButton.js";
import CmsComponentGlyph from "@/helpers/editor/components/CmsComponentGlyph.js";
import CmsComponentImage from "@/helpers/editor/components/CmsComponentImage.js";
import CmsComponentLink from "@/helpers/editor/components/CmsComponentLink.js";
import CmsComponentText from "@/helpers/editor/components/CmsComponentText.js";
import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import {tr} from "@vue-components/helpers/I18nPluginHelper.js";
import {extractHtmlText} from "@vue-components/helpers/utils.js";

export default class CmsBlockCard extends CmsBlock {
    static typeDef = {
        name: `Card|Carte`,
        glyph: `fas fa-address-card`,
        type: `card`,
        category: `base`,
        isParent: false
    }

    get displayName() {
        if (this.item) {
            return tr(this.item.name);
        } else {
            return extractHtmlText(tr(this.title.text), 24);
        }
    }

    get layoutPresets() {
        return [
            {
                id: `default`,
                name: `Default|Défaut`
            },
            {
                id: `reversed`,
                name: `Image Last|Image à la fin`
            },
            {
                id: `row-left`,
                name: `Row Left|Ligne à gauche`
            },
            {
                id: `row-right`,
                name: `Row Right|Ligne à droite`
            }
        ]
    }

    constructor(data, page) {
        super(data, page);

        // tmp cleanup
        if (typeof this.link === `object` && this.link.textField === undefined) {
            delete this.link;
        }
        this.link = new CmsComponentLink(this.link);
        this.image = new CmsComponentImage(this.image);
        this.glyph = new CmsComponentGlyph(this.glyph);
        this.title = new CmsComponentText(this.title);
        this.subtitle = new CmsComponentText(this.subtitle);
        this.description = new CmsComponentText(this.description);
        this.mainButton = new CmsComponentButton(this.mainButton);
        this.altButton = new CmsComponentButton(this.altButton);


        if (this.span == null) {
            this.span = 4;
        }

        // vertical alignment of the card content (inherit, top, center, bottom)
        if (this.verticalAlign === undefined) {
            this.verticalAlign = `inherit`;
        }

        if (!data) {
            this.link.active = false;
            this.glyph.active = false;

            this.title.initText({}, `h3`);
            this.title.active = true;

            this.subtitle.initText({}, `h6`);
            this.subtitle.active = false;

            this.description.initText({});
            this.description.active = false;

            this.mainButton.initText({en: `Main Action`, fr: `Action Principale`});
            this.mainButton.active = false;

            this.altButton.initText({en: `Alt Action`, fr: `Action secondaire`});
            this.altButton.active = false;
        }
        if (this.glyph && !this.glyph.glyph && !this.glyph.glyphField) {
            this.glyph.active = false;
        }
    }
}
